<bcb-generic-label [question]="question"></bcb-generic-label>
<mat-form-field appearance="outline">
	<mat-icon *ngIf="prefixIcon" matPrefix>{{ prefixIcon }}</mat-icon>
	<input
		matInput
		[formControl]="control"
		(change)="onInput($any($event.target))"
		(input)="onInput($any($event.target))"
		(blur)="onTouched()"
	/>
	<mat-icon *ngIf="suffixIcon" matSuffix>{{ suffixIcon }}</mat-icon>
	<mat-hint *ngIf="hint" [align]="hint?.horizontalPosition">{{
		hint.value
	}}</mat-hint>
	<mat-error *ngIf="control?.invalid">{{ errorMessage }}</mat-error>
</mat-form-field>
